export const footer = {
  footer: {
    historyAndCats: 'Стадикэтс / подготовка к егэ и огэ',
    pavelDeuce: 'Разработчики котики - Павел и Леонид',
  },
};
